export default __webpack_public_path__ + "static/media/E3.ee6ee84a.mp3";